import { Link } from 'react-router-dom';

import { displayName } from '../shared/branding';
import { useTranslation } from '../shared/i18n/useTranslation';

export function SignupPage() {
  const { t } = useTranslation();
  return (
    <main className="mx-auto flex min-h-screen max-w-md flex-col justify-center gap-4 p-6">
      <p className="text-sm uppercase tracking-wide text-brand-700">
        {displayName('user-facing')}
      </p>
      <h1 className="text-3xl font-bold text-fg-DEFAULT">{t('auth.signup.title')}</h1>
      <p className="text-fg-muted">{t('auth.signup.placeholder')}</p>
      <Link
        to="/login"
        className="inline-flex min-h-[48px] w-fit items-center rounded-lg bg-brand-800 px-5 font-medium text-white"
      >
        {t('auth.login.submit')}
      </Link>
    </main>
  );
}
